import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';

export interface PatentBatchImagesResponse {
    [key: string]: {
        url: string
        url_120: string
    }
}

export interface IPImageSearchPatentApi {
    patentBatchImages: (patent_ids: string[]) => Promise<PatentBatchImagesResponse>
}

export const IPImageSearchPatentApi = Symbol('IPImageSearchPatentApi');

@injectable()
export class IPImageSearchPatentApiImpl extends PsHttpService implements IPImageSearchPatentApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`,
        }
    }

    patentBatchImages(patent_ids: string[]) {
        return this.post<PatSnapCommonResponseData<PatentBatchImagesResponse>>({
            url: '/patent/batch-images',
            cache: true,
            data: {
                patent_ids,
            },
        })
            .then((res) => {
                return res?.data as unknown as PatentBatchImagesResponse;
            })
    }
}
